import React from 'react';

const Program = () => {
  return (
    <div className="container mx-auto px-4">
      <h1 className="text-4xl font-extrabold text-light-orange mt-12 mb-8">
        Program
      </h1>

      <a
        href="/AMMET2025Program.pdf"
        download
        className="text-white bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 font-semibold text-sm rounded-lg px-4 py-2 shadow-md transition-all duration-200 ease-in-out"
      >
        ⬇ Download Program Detail
      </a>

      <div className="mt-8">
        <iframe
          src="/AMMET2025Program.pdf"
          title="AMMET 2025 Program"
          width="100%"
          height="1000px"
          className="w-full border-2 border-gray-300 rounded-lg shadow-md"
        >
          <p>
            Your browser does not support PDFs.
            <a href="/AMMET2025Program.pdf" download className="text-blue-600 underline ml-2">
              Download the PDF
            </a>
            .
          </p>
        </iframe>
      </div>
    </div>
  );
};

export default Program;